var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3068({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7767 27.5557L13.7767 31L-0.000564575 31L-0.000563371 17.2227L3.44375 17.2227L3.44375 25.1201L12.6812 15.8825C13.3537 15.21 14.4442 15.21 15.1167 15.8825C15.7892 16.5552 15.7892 17.6455 15.1167 18.3182L5.87923 27.5557L13.7767 27.5557Z",
    fill: "#6B5CD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5557 13.7783C29.4579 13.7783 31 12.2363 31 10.334L31 3.44537C31 1.54307 29.4579 0.00104986 27.5557 0.00104969L20.667 0.00104909C18.7648 0.00104893 17.2227 1.54307 17.2227 3.44537L17.2227 10.334C17.2227 12.2363 18.7648 13.7783 20.667 13.7783L27.5557 13.7783ZM27.5557 10.334L27.5557 3.44537L20.667 3.44537L20.667 10.334L27.5557 10.334Z",
    fill: "#6B5CD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3068);
export default __webpack_public_path__ + "static/media/Group 3068.a281c278d86601529401f01f78b31612.svg";
export { ForwardRef as ReactComponent };